import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../themes';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-end',
  },

  textField: {
    flex: 1,
  },
  marginLeft: {
    marginLeft: theme.spacing(2),
  },
  textFieldLightTheme: {
    color: Colors.black,
    '& .MuiInputBase-input': {
      color: Colors.black,
    },
    '& .MuiFormLabel-root': {
      color: Colors.disabledGrey,
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: `2px solid ${Colors.hoverGrey}`,
    },
  },
  searchButton: {
    margin: 8,
    marginLeft: 16,
    marginRight: 10,
    width: 38,
    maxWidth: 38,
    minWidth: 38,
    height: 38,
    maxHeight: 38,
    minHeight: 38,
    padding: '7px 10px',
    borderColor: Colors.white,
    '&:hover:not(.Mui-disabled)': {
      color: Colors.white,
      background: Colors.disabledGrey,
      borderColor: Colors.disabledGrey,
    },
    '& .MuiButton-label': {
      maxWidth: 24,
      minWidth: 24,
      maxHeight: 24,
    },
  },
  lightThemeButton: {
    color: Colors.black,
    borderColor: Colors.black,
    '&:hover': {
      color: Colors.white,
      borderColor: Colors.disabledGrey,
    },
  },
  alignWithAuditBigScreen: {
    marginRight: -5,
  },
  alignWithAuditSmallScreen: {
    marginRight: 0,
  },
}));

const SearchField = (props) => {
  const [value, setValue] = useState('');
  const { searchPlaceholder, lightTheme, alignWithAuditBigScreen, alignWithAuditSmallScreen } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const onKeyPress = props.onKeyPress ? props.onKeyPress : null;
  const widthStyle = props.width && { width: props.width };
  const leftMarginStyle = props.marginLeft && { marginLeft: props.marginLeft };

  return (
    <form
      noValidate
      autoComplete="off"
      className={classes.container}
      style={{ ...widthStyle, ...leftMarginStyle }}
      onSubmit={(e) => e.preventDefault()}
      onKeyPress={(event) => onKeyPress(event, value)}
    >
      <TextField
        id={`textField-${Date.now()}`}
        value={value}
        onChange={(event) => setValue(event.target.value)}
        label={searchPlaceholder || t('table.search')}
        type="search"
        className={clsx([
          classes.textField,
          !alignWithAuditSmallScreen && classes.marginLeft,
          lightTheme && classes.textFieldLightTheme,
        ])}
        margin="normal"
        style={props.textFieldWidth && { width: props.textFieldWidth }}
        InputLabelProps={{ shrink: true }}
      />
      <Button
        className={clsx([
          classes.searchButton,
          lightTheme && classes.lightThemeButton,
          alignWithAuditSmallScreen && classes.alignWithAuditSmallScreen,
          alignWithAuditBigScreen && classes.alignWithAuditBigScreen,
        ])}
        variant="outlined"
        onClick={() => props.onSearchSubmit(value)}
        disabled={props.searchDisabled}
      >
        <SearchIcon />
      </Button>
    </form>
  );
};

export default SearchField;
